<div [navbarHeight]="80" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
  @if (businessDirectory.videoUrl) {
    <div class="row mb-5">
      <div class="col-12">
        <div class="video-panel">
          <div class="video-container">
            <iframe
              class="embed-responsive-item"
              title="business video"
              [src]="businessDirectory.videoUrl | formatVideoURL"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  }
  @if (businessDirectory.companyDetail?.description) {
    <div class="row mb-5" id="summary">
      <div class="col-12">
        <div class="campaign-subtitle text-primary">
          {{ 'company.summary' | translate }}
        </div>
        <div class="mt-3">
          {{ businessDirectory.companyDetail.description }}
        </div>
      </div>
    </div>
  }
  @if (businessDirectory.companyDetail?.info) {
    <div class="row mb-5" id="about">
      <div class="col-12">
        <div class="campaign-subtitle text-primary">
          {{ 'company.about' | translate }}
        </div>
        <div
          class="mt-3 ck-content"
          [innerHTML]="businessDirectory.companyDetail.info | trustSrc"
        ></div>
      </div>
    </div>
  }
</div>
